import { SoQLType } from 'common/types/soql';
import { aggregateRows } from '../gridDataAggregator';
import { createGroupKey } from './groupKey';
import { type IServerSideGetRowsRequest } from 'ag-grid-community';
import { type NormalRow } from '../type';
import { type TableColumn } from '../../types';

export const convertValueColsToTableColumns = (
  valueCols: IServerSideGetRowsRequest['valueCols'],
  pivotTableColumns: TableColumn[],
): TableColumn[] => {
  const columnTypeMap = new Map(pivotTableColumns.map((col) => [col.field, col.type]));
  return valueCols.map((valueCol) => ({
    field: valueCol.id,
    displayName: valueCol.displayName || valueCol.id,
    type: columnTypeMap.get(valueCol.id) || SoQLType.SoQLTextT,
    aggFunc: valueCol.aggFunc?.toString(),
    isGrouped: false,
  }));
};

export const aggregateRowsByGrouping = (
  rows: NormalRow[],
  agRequest: IServerSideGetRowsRequest,
  pivotTableColumns: TableColumn[],
): NormalRow[] => {
  const { rowGroupCols, pivotCols, valueCols } = agRequest;

  const groupingColumnIds = [...rowGroupCols.map((col) => col.id), ...pivotCols.map((col) => col.id)];

  const tableColumns = convertValueColsToTableColumns(valueCols, pivotTableColumns);
  const groupsMap = new Map<string, NormalRow[]>();

  for (const row of rows) {
    const groupKey = createGroupKey(row, groupingColumnIds);
    const group = groupsMap.get(groupKey);

    if (group) {
      group.push(row);
    } else {
      groupsMap.set(groupKey, [row]);
    }
  }

  const aggregatedRows: NormalRow[] = [];

  for (const [, groupRows] of groupsMap) {
    const aggregatedRow: NormalRow = {};

    for (const colId of groupingColumnIds) {
      aggregatedRow[colId] = groupRows[0][colId];
    }

    const aggregations = aggregateRows(groupRows, tableColumns);
    Object.assign(aggregatedRow, aggregations);

    aggregatedRows.push(aggregatedRow);
  }

  return aggregatedRows;
};
